/**
 * @generated SignedSource<<3f332903c97266a419fc0a40b34b2671>>
 * @relayHash 323e53376b4550f51825bad7230c73c4
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 323e53376b4550f51825bad7230c73c4

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type JobPostingDuration = "LONG" | "MONTH" | "QUARTER" | "SHORT" | "WEEK" | "%future added value";
export type Language = "AMERICAN_SIGN_LANGUAGE" | "ARABIC" | "CANTONESE" | "DUTCH" | "ENGLISH" | "FRENCH" | "GERMAN" | "HINDI" | "ITALIAN" | "JAPANESE" | "KOREAN" | "MANDARIN" | "PORTUGUESE" | "RUSSIAN" | "SPANISH" | "THAI" | "TURKISH" | "UKRAINIAN" | "%future added value";
export type LanguageProficiencyLevel = "FLUENT" | "LIMITED_WORKING" | "PROFESSIONAL_WORKING" | "%future added value";
export type UpdateWorkPreferencesInput = {
  availableUntil?: ContraAPIScalars.Date | null;
  blockAvailabilityReminder?: boolean | null;
  jobDurations?: ReadonlyArray<JobPostingDuration> | null;
  languages?: ReadonlyArray<LanguageProficiencyInput> | null;
  minimumHourlyRate?: number | null;
  timezoneOffsetTolerance?: number | null;
  timezonePrimaryUtcOffset?: number | null;
  toolIds?: ReadonlyArray<string> | null;
};
export type LanguageProficiencyInput = {
  languageName: Language;
  proficiency: LanguageProficiencyLevel;
};
export type useUserAvailabilityModalMutation$variables = {
  input: UpdateWorkPreferencesInput;
};
export type useUserAvailabilityModalMutation$data = {
  readonly updateWorkPreferences: {
    readonly errors: ReadonlyArray<{
      readonly __typename: string;
      readonly message: string;
    }> | null;
    readonly userProfile: {
      readonly " $fragmentSpreads": FragmentRefs<"ProfileSidebarAvatarV2_userProfile">;
    } | null;
  };
};
export type useUserAvailabilityModalMutation = {
  response: useUserAvailabilityModalMutation$data;
  variables: useUserAvailabilityModalMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "message",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v5 = [
  (v4/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useUserAvailabilityModalMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UpdateWorkPreferencesPayload",
        "kind": "LinkedField",
        "name": "updateWorkPreferences",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "UserProfile",
            "kind": "LinkedField",
            "name": "userProfile",
            "plural": false,
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "ProfileSidebarAvatarV2_userProfile"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useUserAvailabilityModalMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UpdateWorkPreferencesPayload",
        "kind": "LinkedField",
        "name": "updateWorkPreferences",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": (v5/*: any*/),
                "type": "CollaboratorNotFoundError",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": (v5/*: any*/),
                "type": "CollaboratorRoleCountInvalidError",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": (v5/*: any*/),
                "type": "OrganizationNotFoundError",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": (v5/*: any*/),
                "type": "ProductizedServiceCollaboratorNotFound",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": (v5/*: any*/),
                "type": "ReferBasicOpportunityUserNotFound",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": (v5/*: any*/),
                "type": "SubmitJoinOrganizationRequestError",
                "abstractKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "UserProfile",
            "kind": "LinkedField",
            "name": "userProfile",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "firstName",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "lastName",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "visitorCanEdit",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "displayUsername",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasCompletedIndyOnboarding",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "ContraImage",
                "kind": "LinkedField",
                "name": "avatarImage",
                "plural": false,
                "selections": [
                  (v4/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "url",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "uid",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "analyticsId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "WorkPreferences",
                "kind": "LinkedField",
                "name": "workPreferences",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "isCurrentlyAvailable",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "availableUntil",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v4/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "323e53376b4550f51825bad7230c73c4",
    "metadata": {},
    "name": "useUserAvailabilityModalMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "c9c4c7ddd5750ec4b14f1a6a03039c84";

export default node;
